module.exports = __webpack_public_path__ + "static/media/chris-tree.ee7d2d15.png";